export default {
    Success: 0,
    AlreadyExist: 1,
    NotAuthorized: 2,
    InvalidData: 3,
    NotFound: 4,
    Blocked: 5,
    ServerError: 6,
}